export const SET_UNSUBSCRIBE_LISTENER = "setUnsubscribeListener";
export const CLEAR = "clear";
export const REMOVE_BY_ENTITY_UID = "removeByEntityUid";
export const REMOVE_BY_TYPE_AND_TOPIC = "removeByTypeAndTopic";
export const ADD_IGNORE_CONTENT_ENTITY_UPDATE = "addIgnoreContentEntityUpdate";
export const REMOVE_IGNORE_CONTENT_ENTITY_UPDATE = "removeIgnoreContentEntityUpdate";
export const ADD_UNSEEN_CONTENT = "addUnseenContent";
export const SET_POST_TIMELINE_RELOAD = "setPostTimelineReload";
